import { cdnUri } from "../helpers/app.helper";

export const DefaultProfilePhoto = cdnUri('assets/img/default-profile-photo.jpg');
